var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMajorMedicalInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.874,
    height: 123.504,
    viewBox: "0 0 111.874 123.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(-215.563 -769.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M298.242,821.989H284V807.746a2.035,2.035,0,0,0-2.035-2.035H268.012a2.035,2.035,0,0,0-2.035,2.035v14.243H251.734a2.035,2.035,0,0,0-2.035,2.035v13.952a2.035,2.035,0,0,0,2.035,2.035h14.243v14.243a2.035,2.035,0,0,0,2.035,2.035h13.952A2.035,2.035,0,0,0,284,854.254V840.011h14.243a2.035,2.035,0,0,0,2.035-2.035V824.024A2.035,2.035,0,0,0,298.242,821.989Z",
    fill: "#e1e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M325.266,791.634a2.034,2.034,0,0,0-1.433-1.729,469.546,469.546,0,0,1-51.494-18.724,2.037,2.037,0,0,0-1.678,0,469.545,469.545,0,0,1-51.494,18.724,2.034,2.034,0,0,0-1.433,1.729,131.909,131.909,0,0,0,3.386,41.79c7.275,29.216,24.475,49.09,49.739,57.473a2.045,2.045,0,0,0,1.282,0c25.264-8.383,42.464-28.257,49.739-57.473A131.908,131.908,0,0,0,325.266,791.634Z",
    fill: "none",
    stroke: "#bcbec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.488
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M239.573,835.163a125.563,125.563,0,0,1-3.607-32.9,2.036,2.036,0,0,1,1.421-1.9c19.319-6.111,34.01-11.957,41.6-15.145-2.671-1.073-4.919-2.007-6.688-2.757a2.032,2.032,0,0,0-1.59,0c-7.242,3.073-22.409,9.183-42.62,15.576a2.034,2.034,0,0,0-1.42,1.9,125.5,125.5,0,0,0,3.606,32.9c6.314,24.836,19.94,41.428,40.5,49.316a2.036,2.036,0,0,0,1.458,0c.473-.182.922-.391,1.387-.582C256.646,872.858,245.2,857.293,239.573,835.163Z",
    fill: "#e1e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M314.915,796.881c-20.211-6.393-35.378-12.5-42.62-15.577a2.032,2.032,0,0,0-1.59,0c-7.242,3.073-22.409,9.184-42.62,15.577a2.034,2.034,0,0,0-1.42,1.9,125.52,125.52,0,0,0,3.607,32.9c6.313,24.835,19.939,41.427,40.5,49.315a2.036,2.036,0,0,0,1.458,0c20.56-7.888,34.186-24.48,40.5-49.315a125.527,125.527,0,0,0,3.607-32.9A2.034,2.034,0,0,0,314.915,796.881Z",
    fill: "none",
    stroke: "#bcbec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.488
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M294.754,818.5H280.511V804.258a2.035,2.035,0,0,0-2.035-2.035H264.524a2.035,2.035,0,0,0-2.035,2.035V818.5H248.246a2.035,2.035,0,0,0-2.035,2.035v13.952a2.035,2.035,0,0,0,2.035,2.035h14.243v14.243a2.035,2.035,0,0,0,2.035,2.035h13.952a2.035,2.035,0,0,0,2.035-2.035V836.523h14.243a2.035,2.035,0,0,0,2.035-2.035V820.536A2.035,2.035,0,0,0,294.754,818.5Z",
    fill: "none",
    stroke: "#bcbec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.488
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajorMedicalInactive);
export default __webpack_public_path__ + "static/media/major-medical-inactive.1dd74e73d70b60af7757641e6e2d1ce7.svg";
export { ForwardRef as ReactComponent };